module.exports = __webpack_public_path__ + "img/kk-logo.fdc2d997.svg";